import * as Const from "../../Const";
import L from 'leaflet';

export const guideLinePathOptions = { color: '#ff00ff', weight: 3, dashArray: '6,3', pane: Const.PANE_NAME_PARCEL_EDITOR_WORK };
export const generatedLinePathOptions = { color: '#ffffff', weight: 2, dashArray: '4,2', pane: Const.PANE_NAME_PARCEL_EDITOR_WORK };
export const generatedLinePathExtensionOptions = { color: '#ffffff', weight: 2, dashArray: '4,2', pane: Const.PANE_NAME_PARCEL_EDITOR_WORK };
export const servicePathOptions = { color: '#ccccff', weight: 2, dashArray: '2,4', editable: true, interactive: true, pane: Const.PANE_NAME_PARCEL_EDITOR_WORK };

export const wateringPointOptions = { radius: 6, weight: 1, fill: true, color: '#fff', fillColor: '#fff', fillOpacity: 0.6, pane: Const.PANE_NAME_PARCEL_EDITOR_WORK };
export const activeWateringPointOptions = { radius: 10, fill: true, color: '#0e4', fillColor: '#0e4', fillOpacity: 1, interactive:false, pane: Const.PANE_NAME_PARCEL_EDITOR_WORK };
export const wateringPathOptions = { color: '#eeeeee', weight: 2, dashArray: null, editable: false, interactive: false, pane: Const.PANE_NAME_PARCEL_EDITOR_WORK };
export const activeWateringPathOptions = { color: '#00dd33ff', weight: 5, dashArray: null, editable: false, interactive: false, pane: Const.PANE_NAME_PARCEL_EDITOR_WORK };
export const activeWateringSequenceOptions = { color: '#22bbffff', weight: 3, dashArray: null, editable: false, interactive: false, pane: Const.PANE_NAME_PARCEL_EDITOR_WORK };

export const waterApplicationPolygonOptions = { fill: true, fillColor: '#5555ffdd', interactive: false, editable: false, pane: Const.PANE_NAME_PARCEL_EDITOR_WORK };

export const geoFenceAreaOptions = { color: 'red', weight: 1.8, dashArray: '6,5,2,5', editable: false, interactive: true, pane: Const.PANE_NAME_PARCELS };
export const workAreaOptions = { color: 'blue', weight: 0.8, dashArray: '2,4', editable: false, interactive: true, pane: Const.PANE_NAME_PARCELS };

export const indexIgnore = 0;
export const indexWorkArea = 1;
export const indexGeoFence = 2;
export const indexReferencePath = 3;

export const rainRoverPathOptions = [
    null,
    null,
    null,
    guideLinePathOptions
];


export const stepIndexLoadKML = 0;
export const stepIndexSelectFeatures = 1;
export const stepIndexPlaceWaterSource = 2;
export const stepIndexPlaceReferencePath = 3;
export const stepIndexGenerateRows = 4;
export const stepIndexGenerateServicePath = 5;
export const stepIndexPlanRoute = 6;



export const waterSourceIcon = L.icon({
    iconUrl: 'assets/icons/water_source.png',
    iconSize: [28, 28],
    iconAnchor: [14, 14]
});


export const waterSourceMarkerOptions = {
    // pane: Const.PANE_NAME_MACHINES,
    icon: waterSourceIcon,
    id: "WATER"
}


export const pathMarkerIcon = L.icon({
    iconUrl: 'assets/icons/assistant_navigation_no_heading.png',
    iconSize: [28, 28],
    iconAnchor: [14, 14]
});

export const editablePathMarkerOptions = {
    icon: pathMarkerIcon
}


export const pathTypeApproach = 0;
export const pathTypeService = 1;
export const pathTypeServiceExtension = 2;
export const pathTypeHeadland = 3;
export const pathTypeHeadlandExtension = 4;
export const pathTypeWatering = 5;
export const pathTypeWateringExtension = 6;

export const pathTypeColors = [
    '#f80',
    '#ff0',
    '#cc0',
    '#4d7',
    '#2a4',
    '#eef',
    '#7af'
];
